//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import MButton from "./MButton";
const { FabricAdvanced, store, computed } = window.MattingEngineModule;
import Icon from "./Icon";

export default {
  name: "MattingAdvancedCanvas",
  components: {
    // MButton,
    Icon,
  },
  mounted() {
    new FabricAdvanced(this.$refs.advanced, {
      container: this.$refs.container,
    });
  },
  computed: {
    ...computed,
    zoomLevelAdvanced() {
      return store.advancedManager.zoomLevelAdvanced;
    },
    panActive() {
      return this.state.matches("pan");
    },
  },
  filters: {
    percent(val) {
      if (typeof val === "number") {
        return Math.round(val * 100);
      } else {
        return val;
      }
    },
  },

  methods: {
    zoomIn() {
      store.advancedManager.zoomIn();
    },
    zoomOut() {
      store.advancedManager.zoomOut();
    },
    upload() {
      this.$root.$emit("matting:create");
    },
    download() {
      this.$root.$emit("matting:download", "advanced");
    },
  },
};
